module.exports = __webpack_public_path__ + "static/media/questionMark.8d390a8b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/icons/questionMark.svg
// module id = 1464
// module chunks = 0